import { getInstance } from "./authWrapper";

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const fn = () => {
    if (authService.isAuthenticated) {
      return next();
    }
    // in case you want to navigate to auth0 then do authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
    next({ path: `/landingpage?redirectTo=${to.fullPath}` });
  };

  if (!authService.loading) {
    return fn();
  }

  authService.$watch("loading", loading => {
    if (loading === false) {
      return fn();
    }
  });
};
